import { useState } from "react";
import { StatIcon } from "../assets/gameIcons.js";
import { useT } from "../i18n/index.js";
import { Icon } from "../ui/Icon.js";
import { Timer, useServerTick } from "../ui/Timer.js";
import type { WorldMe } from "./types.js";
import { FuelSheet } from "./FuelSheet.js";

/** The fuel chip on the map: current stock, regeneration, and a tap opens refills and offers (D65). */
export function StaminaStock({ stamina }: { stamina: WorldMe["stamina"] | undefined }) {
  const t = useT(), now = useServerTick(1);
  const [open, setOpen] = useState(false);
  const interval = stamina?.intervalMs;
  const earned = interval && stamina?.nextAt != null && now >= stamina.nextAt ? 1 + Math.floor((now - stamina.nextAt) / interval) : 0;
  const current = stamina ? Math.max(stamina.current, Math.min(stamina.cap, stamina.current + earned)) : 0;
  const next = interval && stamina?.nextAt != null ? stamina.nextAt + earned * interval : null;
  return <>
    <button type="button" className="chip world-stamina-stock" onClick={() => setOpen(true)} data-testid="chip-stamina" aria-label={t("fuel.open")}>
      <StatIcon stat="stamina" /><span><strong>{stamina ? `${current}/${stamina.cap}` : "…"}</strong>
        {stamina ? <small>{current >= stamina.cap ? t("world.stamina.full") : next ? <>{t("world.stamina.next")} <Timer finishesAt={next} /></> : null}</small> : null}
        {interval ? <small>{t("world.stamina.regen", { minutes: interval / 60_000 })}</small> : null}
      </span>
      <span className="fuel-plus" aria-hidden><Icon name="plus" size={14} /></span>
    </button>
    {open ? <FuelSheet onClose={() => setOpen(false)} /> : null}
  </>;
}
